import React, { useState, Component } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Search, Globe, Zap, Layout, Printer, Users, TrendingUp, MessageSquare, Shield, PenTool, CreditCard, ArrowRight, CheckCircle2, BarChart3, FileText, Plus, Settings, Bell, Menu, X, Monitor, Smartphone, Layers, MousePointer2, ChevronDown, ChevronRight } from 'lucide-react';
import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, BarChart, Bar } from 'recharts';
const growthData = [{
  name: 'Mon',
  traffic: 2400,
  roi: 400,
  subs: 240
}, {
  name: 'Tue',
  traffic: 1398,
  roi: 300,
  subs: 139
}, {
  name: 'Wed',
  traffic: 9800,
  roi: 2000,
  subs: 980
}, {
  name: 'Thu',
  traffic: 3908,
  roi: 2780,
  subs: 390
}, {
  name: 'Fri',
  traffic: 4800,
  roi: 1890,
  subs: 480
}, {
  name: 'Sat',
  traffic: 3800,
  roi: 2390,
  subs: 380
}, {
  name: 'Sun',
  traffic: 4300,
  roi: 3490,
  subs: 430
}];
interface MySpeedyXProps {
  onBack?: () => void;
}
export function MySpeedyX({
  onBack
}: MySpeedyXProps) {
  const [view, setView] = useState<'public' | 'agent'>('public');
  const [activeSection, setActiveSection] = useState<'home' | 'hosting' | 'marketing' | 'graphics' | 'print'>('home');
  const [agentSubPage, setAgentSubPage] = useState<null | 'builder' | 'forms' | 'security' | 'nodes'>(null);
  const [activeTab, setActiveTab] = useState('growth');
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  return <div className="min-h-screen bg-white text-slate-900 font-['Inter'] selection:bg-[#00E5FF] selection:text-slate-900" data-id="element-1148">
      {/* Header */}
      <header className="fixed top-0 left-0 right-0 z-50 bg-white/80 backdrop-blur-md border-b border-slate-100 px-6 py-4" data-id="element-1149">
        <div className="max-w-7xl mx-auto flex items-center justify-between" data-id="element-1150">
          <div className="flex items-center gap-2 cursor-pointer" onClick={() => {
          setActiveSection('home');
          setView('public');
        }} data-id="element-1151">
            <div className="w-10 h-10 bg-[#002366] rounded flex items-center justify-center" data-id="element-1152">
              <Zap className="text-[#00E5FF]" size={24} data-id="element-1153" />
            </div>
            <span className="font-bold text-xl tracking-tight text-[#002366]" data-id="element-1154">
              MySpeedyX
            </span>
          </div>

          <nav className="hidden md:flex items-center gap-8 text-sm font-semibold text-slate-600" data-id="element-1155">
            <div className="relative group" data-id="element-1156">
              <button className="hover:text-[#002366] transition-colors flex items-center gap-1" data-id="element-1157">
                Solutions <ChevronDown size={14} data-id="element-1158" />
              </button>
              <div className="absolute top-full left-0 w-64 bg-white border border-slate-100 shadow-xl rounded-xl p-2 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all" data-id="element-1159">
                <button onClick={() => setActiveSection('hosting')} className="w-full text-left px-4 py-3 hover:bg-slate-50 rounded-lg flex items-center gap-3" data-id="element-1160">
                  <Globe size={18} className="text-blue-600" data-id="element-1161" />
                  <div data-id="element-1162">
                    <p className="text-sm font-bold text-[#002366]" data-id="element-1163">
                      Web & Hosting
                    </p>
                    <p className="text-[10px] text-slate-400" data-id="element-1164">
                      Managed servers & domains
                    </p>
                  </div>
                </button>
                <button onClick={() => setActiveSection('marketing')} className="w-full text-left px-4 py-3 hover:bg-slate-50 rounded-lg flex items-center gap-3" data-id="element-1165">
                  <TrendingUp size={18} className="text-cyan-600" data-id="element-1166" />
                  <div data-id="element-1167">
                    <p className="text-sm font-bold text-[#002366]" data-id="element-1168">
                      Marketing & SEO
                    </p>
                    <p className="text-[10px] text-slate-400" data-id="element-1169">
                      Lead gen & visibility
                    </p>
                  </div>
                </button>
                <button onClick={() => setActiveSection('graphics')} className="w-full text-left px-4 py-3 hover:bg-slate-50 rounded-lg flex items-center gap-3" data-id="element-1170">
                  <PenTool size={18} className="text-indigo-600" data-id="element-1171" />
                  <div data-id="element-1172">
                    <p className="text-sm font-bold text-[#002366]" data-id="element-1173">
                      Graphics & Design
                    </p>
                    <p className="text-[10px] text-slate-400" data-id="element-1174">
                      Creative & brand identity
                    </p>
                  </div>
                </button>
                <button onClick={() => setActiveSection('print')} className="w-full text-left px-4 py-3 hover:bg-slate-50 rounded-lg flex items-center gap-3" data-id="element-1175">
                  <Printer size={18} className="text-slate-600" data-id="element-1176" />
                  <div data-id="element-1177">
                    <p className="text-sm font-bold text-[#002366]" data-id="element-1178">
                      Premium Print
                    </p>
                    <p className="text-[10px] text-slate-400" data-id="element-1179">
                      Physical business assets
                    </p>
                  </div>
                </button>
              </div>
            </div>
            <button onClick={() => setActiveSection('hosting')} className="hover:text-[#002366] transition-colors" data-id="element-1180">
              Hosting
            </button>
            <button onClick={() => setActiveSection('print')} className="hover:text-[#002366] transition-colors" data-id="element-1181">
              Print
            </button>
            <a href="#" className="hover:text-[#002366] transition-colors" data-id="element-1182">
              Pricing
            </a>
          </nav>

          <div className="flex items-center gap-3" data-id="element-1183">
            {onBack && <button onClick={onBack} className="text-xs font-bold text-slate-400 hover:text-slate-600 mr-4" data-id="element-1184">
                ← Admin
              </button>}
            <button className="hidden sm:block text-sm font-bold text-[#002366] px-4 py-2 hover:bg-slate-50 rounded-lg transition-colors" data-id="element-1185">
              Customer Login
            </button>
            <button onClick={() => setView(view === 'public' ? 'agent' : 'public')} className="bg-[#002366] text-white px-6 py-2.5 rounded-lg font-bold text-sm hover:bg-[#001a4d] transition-all shadow-lg shadow-blue-900/20" data-id="element-1186">
              {view === 'public' ? 'Join as Agent' : 'Exit Dashboard'}
            </button>
            <button className="md:hidden" onClick={() => setIsMenuOpen(!isMenuOpen)} data-id="element-1187">
              {isMenuOpen ? <X data-id="element-1188" /> : <Menu data-id="element-1189" />}
            </button>
          </div>
        </div>
      </header>

      {view === 'public' ? <main className="pt-24" data-id="element-1190">
          {activeSection === 'home' && <>
              {/* Hero Section */}
              <section className="relative py-24 md:py-32 px-6 overflow-hidden bg-slate-50" data-id="element-1191">
                <div className="max-w-7xl mx-auto text-center relative z-10" data-id="element-1192">
                  <motion.h1 initial={{
              opacity: 0,
              y: 20
            }} animate={{
              opacity: 1,
              y: 0
            }} className="text-5xl md:text-7xl font-extrabold text-[#002366] leading-tight mb-6 tracking-tight" data-id="element-1193">
                    Launch Your Business <br data-id="element-1194" />
                    <span className="text-[#00E5FF]" data-id="element-1195">at Warp Speed.</span>
                  </motion.h1>
                  <p className="text-xl text-slate-500 max-w-2xl mx-auto mb-12 font-medium" data-id="element-1196">
                    Domains, Hosting, Print, and Marketing Services—All in One
                    Hub. The enterprise-grade engine for modern entrepreneurs.
                  </p>

                  {/* Domain Search Bar */}
                  <div className="max-w-3xl mx-auto bg-white p-2 rounded-2xl shadow-2xl shadow-blue-900/5 flex flex-col sm:flex-row items-center border border-slate-100" data-id="element-1197">
                    <div className="flex-1 flex items-center px-4 w-full" data-id="element-1198">
                      <Search className="text-slate-300 mr-3" size={24} data-id="element-1199" />
                      <input type="text" placeholder="Search your perfect domain name..." className="w-full py-4 text-lg focus:outline-none font-medium" data-id="element-1200" />
                    </div>
                    <button className="w-full sm:w-auto bg-[#00E5FF] text-[#002366] px-10 py-4 rounded-xl font-bold text-lg hover:brightness-110 transition-all" data-id="element-1201">
                      Search
                    </button>
                  </div>
                  <div className="mt-6 flex justify-center gap-8 text-xs font-bold text-slate-400 uppercase tracking-widest" data-id="element-1202">
                    <span data-id="element-1203">.com $12.99</span>
                    <span data-id="element-1204">.net $14.99</span>
                    <span data-id="element-1205">.io $39.99</span>
                  </div>
                </div>

                {/* Background Accents */}
                <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-full pointer-events-none opacity-50" data-id="element-1206">
                  <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-blue-100/50 blur-[120px] rounded-full" data-id="element-1207"></div>
                  <div className="absolute bottom-0 left-0 w-[500px] h-[500px] bg-cyan-100/50 blur-[100px] rounded-full" data-id="element-1208"></div>
                </div>
              </section>

              {/* Service Grid */}
              <section className="py-24 px-6 max-w-7xl mx-auto" data-id="element-1209">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-1210">
                  {[{
              id: 'hosting',
              title: 'Web & Hosting',
              desc: 'Managed servers, SSL certificates, and high-speed domains.',
              icon: Globe,
              color: 'text-blue-600',
              bg: 'bg-blue-50'
            }, {
              id: 'marketing',
              title: 'Marketing & SEO',
              desc: 'Lead generation, visibility audits, and growth strategy.',
              icon: TrendingUp,
              color: 'text-cyan-600',
              bg: 'bg-cyan-50'
            }, {
              id: 'graphics',
              title: 'Graphics & Design',
              desc: 'Creative services for digital, social, and brand identity.',
              icon: PenTool,
              color: 'text-indigo-600',
              bg: 'bg-indigo-50'
            }, {
              id: 'print',
              title: 'Premium Print',
              desc: 'Physical business cards, flyers, and high-end banners.',
              icon: Printer,
              color: 'text-slate-600',
              bg: 'bg-slate-100'
            }].map((service, i) => <motion.div key={i} whileHover={{
              y: -8
            }} className="p-8 bg-white rounded-2xl border border-slate-100 shadow-sm hover:shadow-xl hover:border-blue-100 transition-all group" data-id="element-1211">
                      <div className={`w-14 h-14 ${service.bg} ${service.color} rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform`} data-id="element-1212">
                        <service.icon size={28} data-id="element-1213" />
                      </div>
                      <h3 className="text-xl font-bold text-[#002366] mb-3" data-id="element-1214">
                        {service.title}
                      </h3>
                      <p className="text-slate-500 text-sm leading-relaxed mb-6" data-id="element-1215">
                        {service.desc}
                      </p>
                      <button onClick={() => setActiveSection(service.id as any)} className="text-sm font-bold text-[#002366] flex items-center gap-2 group-hover:gap-3 transition-all" data-id="element-1216">
                        Learn More <ArrowRight size={16} data-id="element-1217" />
                      </button>
                    </motion.div>)}
                </div>
              </section>

              {/* Membership CTA */}
              <section className="py-24 px-6" data-id="element-1218">
                <div className="max-w-5xl mx-auto bg-[#002366] rounded-[2rem] p-12 md:p-20 text-center relative overflow-hidden shadow-2xl" data-id="element-1219">
                  <div className="relative z-10" data-id="element-1220">
                    <h2 className="text-3xl md:text-5xl font-bold text-white mb-6" data-id="element-1221">
                      Become a MySpeedyX Partner.
                    </h2>
                    <p className="text-blue-100 text-lg mb-10 max-w-2xl mx-auto" data-id="element-1222">
                      Get your own white-labeled dashboard and start scaling
                      today. Access enterprise infrastructure and wholesale
                      pricing.
                    </p>
                    <button onClick={() => setView('agent')} className="bg-[#00E5FF] text-[#002366] px-10 py-4 rounded-xl font-bold text-lg hover:brightness-110 transition-all shadow-xl shadow-cyan-500/20" data-id="element-1223">
                      Launch My Agent Dashboard
                    </button>
                  </div>
                  <div className="absolute top-0 right-0 w-64 h-64 bg-blue-500/10 blur-[100px] -mr-32 -mt-32" data-id="element-1224"></div>
                  <div className="absolute bottom-0 left-0 w-64 h-64 bg-cyan-500/10 blur-[100px] -ml-32 -mb-32" data-id="element-1225"></div>
                </div>
              </section>
            </>}

          {activeSection === 'hosting' && <section className="py-24 px-6 max-w-7xl mx-auto" data-id="element-1226">
              <div className="flex items-center gap-2 text-sm font-bold text-slate-400 mb-8" data-id="element-1227">
                <button onClick={() => setActiveSection('home')} className="hover:text-[#002366]" data-id="element-1228">
                  Home
                </button>
                <ChevronRight size={14} data-id="element-1229" />
                <span className="text-[#002366]" data-id="element-1230">Web & Hosting</span>
              </div>
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center mb-24" data-id="element-1231">
                <div data-id="element-1232">
                  <h2 className="text-4xl md:text-5xl font-bold text-[#002366] mb-6" data-id="element-1233">
                    Managed Hosting <br data-id="element-1234" />
                    <span className="text-blue-600" data-id="element-1235">Built for Speed.</span>
                  </h2>
                  <p className="text-lg text-slate-500 mb-8 leading-relaxed" data-id="element-1236">
                    Deploy your applications on our high-performance multi-node
                    infrastructure. Every plan includes enterprise-grade
                    security and automated scaling.
                  </p>
                  <div className="space-y-4 mb-10" data-id="element-1237">
                    {['Unlimited NVMe SSD Storage', 'Free SSL Certificates for all domains', 'Automated Daily Backups', '99.99% Uptime Guarantee', 'One-Click App Deployment'].map((f, i) => <div key={i} className="flex items-center gap-3 text-slate-600 font-medium" data-id="element-1238">
                        <CheckCircle2 className="text-blue-600" size={20} data-id="element-1239" />
                        {f}
                      </div>)}
                  </div>
                  <button className="bg-[#002366] text-white px-8 py-4 rounded-xl font-bold hover:brightness-110 transition-all shadow-xl shadow-blue-900/20" data-id="element-1240">
                    View Hosting Plans
                  </button>
                </div>
                <div className="bg-slate-900 rounded-3xl p-8 shadow-2xl relative overflow-hidden" data-id="element-1241">
                  <div className="relative z-10 space-y-6" data-id="element-1242">
                    <div className="flex items-center justify-between border-b border-white/10 pb-4" data-id="element-1243">
                      <div className="flex items-center gap-3" data-id="element-1244">
                        <div className="w-3 h-3 rounded-full bg-red-500" data-id="element-1245"></div>
                        <div className="w-3 h-3 rounded-full bg-amber-500" data-id="element-1246"></div>
                        <div className="w-3 h-3 rounded-full bg-emerald-500" data-id="element-1247"></div>
                      </div>
                      <span className="text-[10px] font-bold text-slate-500 uppercase tracking-widest" data-id="element-1248">
                        Server Status: Optimal
                      </span>
                    </div>
                    <div className="space-y-4 font-mono text-xs text-blue-400" data-id="element-1249">
                      <p data-id="element-1250">$ myspeedyx deploy --cluster-alpha</p>
                      <p className="text-slate-500" data-id="element-1251">
                        Checking node availability...
                      </p>
                      <p className="text-emerald-400" data-id="element-1252">✓ 12 Nodes Online</p>
                      <p className="text-slate-500" data-id="element-1253">
                        Provisioning SSL certificates...
                      </p>
                      <p className="text-emerald-400" data-id="element-1254">
                        ✓ SSL Active (Let's Encrypt)
                      </p>
                      <p className="text-white" data-id="element-1255">
                        Deployment successful: https://your-brand.com
                      </p>
                    </div>
                  </div>
                  <div className="absolute -right-20 -bottom-20 w-64 h-64 bg-blue-500/20 blur-[100px] rounded-full" data-id="element-1256"></div>
                </div>
              </div>
            </section>}

          {activeSection === 'marketing' && <section className="py-24 px-6 max-w-7xl mx-auto" data-id="element-1257">
              <div className="flex items-center gap-2 text-sm font-bold text-slate-400 mb-8" data-id="element-1258">
                <button onClick={() => setActiveSection('home')} className="hover:text-[#002366]" data-id="element-1259">
                  Home
                </button>
                <ChevronRight size={14} data-id="element-1260" />
                <span className="text-[#002366]" data-id="element-1261">Marketing & SEO</span>
              </div>
              <div className="text-center max-w-3xl mx-auto mb-20" data-id="element-1262">
                <h2 className="text-4xl md:text-5xl font-bold text-[#002366] mb-6" data-id="element-1263">
                  Drive Traffic. <br data-id="element-1264" />
                  <span className="text-cyan-600" data-id="element-1265">Convert Leads.</span>
                </h2>
                <p className="text-lg text-slate-500 leading-relaxed" data-id="element-1266">
                  Our marketing engine combines data-driven SEO with
                  high-converting lead generation strategies to scale your
                  business visibility.
                </p>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-1267">
                {[{
            title: 'SEO Visibility',
            desc: 'Dominate search results with our technical SEO audits and keyword strategy.',
            icon: Search
          }, {
            title: 'Lead Generation',
            desc: 'Automated funnels and smart chatbots that capture leads 24/7.',
            icon: Users
          }, {
            title: 'Growth Strategy',
            desc: 'Custom roadmaps designed to scale your ROI and market share.',
            icon: TrendingUp
          }].map((item, i) => <div key={i} className="p-10 bg-white border border-slate-100 rounded-3xl shadow-sm hover:shadow-xl transition-all text-center" data-id="element-1268">
                    <div className="w-16 h-16 bg-cyan-50 text-cyan-600 rounded-2xl flex items-center justify-center mx-auto mb-6" data-id="element-1269">
                      <item.icon size={32} data-id="element-1270" />
                    </div>
                    <h3 className="text-xl font-bold text-[#002366] mb-4" data-id="element-1271">
                      {item.title}
                    </h3>
                    <p className="text-slate-500 text-sm leading-relaxed" data-id="element-1272">
                      {item.desc}
                    </p>
                  </div>)}
              </div>
            </section>}

          {activeSection === 'graphics' && <section className="py-24 px-6 max-w-7xl mx-auto" data-id="element-1273">
              <div className="flex items-center gap-2 text-sm font-bold text-slate-400 mb-8" data-id="element-1274">
                <button onClick={() => setActiveSection('home')} className="hover:text-[#002366]" data-id="element-1275">
                  Home
                </button>
                <ChevronRight size={14} data-id="element-1276" />
                <span className="text-[#002366]" data-id="element-1277">Graphics & Design</span>
              </div>
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-1278">
                <div className="grid grid-cols-2 gap-4" data-id="element-1279">
                  <div className="aspect-square bg-slate-100 rounded-3xl overflow-hidden" data-id="element-1280">
                    <img src="https://images.unsplash.com/photo-1561070791-2526d30994b5?auto=format&fit=crop&q=80&w=400" className="w-full h-full object-cover" alt="Design" data-id="element-1281" />
                  </div>
                  <div className="aspect-square bg-slate-100 rounded-3xl overflow-hidden mt-8" data-id="element-1282">
                    <img src="https://images.unsplash.com/photo-1572044162444-ad60f128bde3?auto=format&fit=crop&q=80&w=400" className="w-full h-full object-cover" alt="Design" data-id="element-1283" />
                  </div>
                </div>
                <div data-id="element-1284">
                  <h2 className="text-4xl md:text-5xl font-bold text-[#002366] mb-6" data-id="element-1285">
                    Creative Excellence <br data-id="element-1286" />
                    <span className="text-indigo-600" data-id="element-1287">for Modern Brands.</span>
                  </h2>
                  <p className="text-lg text-slate-500 mb-8 leading-relaxed" data-id="element-1288">
                    From digital assets to full brand identities, our design
                    team crafts visuals that command attention and drive
                    engagement.
                  </p>
                  <div className="grid grid-cols-2 gap-6 mb-10" data-id="element-1289">
                    <div className="space-y-2" data-id="element-1290">
                      <h4 className="font-bold text-[#002366]" data-id="element-1291">
                        Digital Design
                      </h4>
                      <p className="text-xs text-slate-400" data-id="element-1292">
                        Social media, ads, and web assets.
                      </p>
                    </div>
                    <div className="space-y-2" data-id="element-1293">
                      <h4 className="font-bold text-[#002366]" data-id="element-1294">
                        Brand Identity
                      </h4>
                      <p className="text-xs text-slate-400" data-id="element-1295">
                        Logos, typography, and guidelines.
                      </p>
                    </div>
                  </div>
                  <button className="bg-[#002366] text-white px-8 py-4 rounded-xl font-bold hover:brightness-110 transition-all" data-id="element-1296">
                    Start a Design Project
                  </button>
                </div>
              </div>
            </section>}

          {activeSection === 'print' && <section className="py-24 px-6 max-w-7xl mx-auto" data-id="element-1297">
              <div className="flex items-center gap-2 text-sm font-bold text-slate-400 mb-8" data-id="element-1298">
                <button onClick={() => setActiveSection('home')} className="hover:text-[#002366]" data-id="element-1299">
                  Home
                </button>
                <ChevronRight size={14} data-id="element-1300" />
                <span className="text-[#002366]" data-id="element-1301">Premium Print</span>
              </div>
              <div className="bg-slate-50 rounded-[3rem] p-12 md:p-20 border border-slate-100" data-id="element-1302">
                <div className="flex flex-col lg:flex-row items-center gap-16" data-id="element-1303">
                  <div className="flex-1" data-id="element-1304">
                    <h2 className="text-4xl md:text-5xl font-bold text-[#002366] mb-6" data-id="element-1305">
                      High-Impact <br data-id="element-1306" />
                      <span className="text-slate-600" data-id="element-1307">Physical Assets.</span>
                    </h2>
                    <p className="text-lg text-slate-500 mb-8 leading-relaxed" data-id="element-1308">
                      Premium print quality for business cards, flyers, and
                      banners. Fast turnaround and nationwide shipping.
                    </p>
                    <div className="grid grid-cols-2 gap-4 mb-10" data-id="element-1309">
                      <div className="p-4 bg-white rounded-2xl border border-slate-100 shadow-sm" data-id="element-1310">
                        <Printer size={24} className="text-slate-400 mb-2" data-id="element-1311" />
                        <p className="font-bold text-sm" data-id="element-1312">Business Cards</p>
                        <p className="text-[10px] text-slate-400" data-id="element-1313">
                          Premium cardstock
                        </p>
                      </div>
                      <div className="p-4 bg-white rounded-2xl border border-slate-100 shadow-sm" data-id="element-1314">
                        <LayoutIcon size={24} className="text-slate-400 mb-2" data-id="element-1315" />
                        <p className="font-bold text-sm" data-id="element-1316">Flyers & Posters</p>
                        <p className="text-[10px] text-slate-400" data-id="element-1317">
                          Vibrant colors
                        </p>
                      </div>
                    </div>
                    <button className="bg-[#002366] text-white px-8 py-4 rounded-xl font-bold hover:brightness-110 transition-all" data-id="element-1318">
                      Browse Print Catalog
                    </button>
                  </div>
                  <div className="flex-1 grid grid-cols-2 gap-4" data-id="element-1319">
                    <div className="aspect-[3/4] bg-white rounded-2xl shadow-xl border border-slate-100 p-6 flex flex-col justify-between" data-id="element-1320">
                      <div className="w-10 h-10 bg-slate-100 rounded-lg" data-id="element-1321"></div>
                      <div className="space-y-2" data-id="element-1322">
                        <div className="h-2 w-20 bg-slate-100 rounded" data-id="element-1323"></div>
                        <div className="h-2 w-16 bg-slate-50 rounded" data-id="element-1324"></div>
                      </div>
                    </div>
                    <div className="aspect-[3/4] bg-white rounded-2xl shadow-xl border border-slate-100 p-6 flex flex-col justify-between mt-12" data-id="element-1325">
                      <div className="w-10 h-10 bg-slate-100 rounded-lg" data-id="element-1326"></div>
                      <div className="space-y-2" data-id="element-1327">
                        <div className="h-2 w-20 bg-slate-100 rounded" data-id="element-1328"></div>
                        <div className="h-2 w-16 bg-slate-50 rounded" data-id="element-1329"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>}
        </main> : <main className="pt-24 pb-12 px-6 bg-slate-50 min-h-screen" data-id="element-1330">
          <div className="max-w-7xl mx-auto" data-id="element-1331">
            {!agentSubPage ? <>
                <div className="flex flex-col md:flex-row md:items-center justify-between gap-6 mb-8" data-id="element-1332">
                  <div data-id="element-1333">
                    <h1 className="text-3xl font-bold text-[#002366]" data-id="element-1334">
                      Agent Nerve Center
                    </h1>
                    <p className="text-slate-500 font-medium" data-id="element-1335">
                      Welcome back, Agent 001. Your empire is scaling.
                    </p>
                  </div>
                  <div className="flex gap-3" data-id="element-1336">
                    <button className="p-2 bg-white border border-slate-200 rounded-lg text-slate-400 hover:text-[#002366] transition-colors relative" data-id="element-1337">
                      <Bell size={20} data-id="element-1338" />
                      <span className="absolute top-2 right-2 w-2 h-2 bg-red-500 rounded-full border-2 border-white" data-id="element-1339"></span>
                    </button>
                    <button className="p-2 bg-white border border-slate-200 rounded-lg text-slate-400 hover:text-[#002366] transition-colors" data-id="element-1340">
                      <Settings size={20} data-id="element-1341" />
                    </button>
                  </div>
                </div>

                {/* Dashboard Tabs */}
                <div className="bg-white rounded-2xl border border-slate-200 shadow-sm overflow-hidden mb-8" data-id="element-1342">
                  <div className="flex border-b border-slate-100 px-4 overflow-x-auto no-scrollbar" data-id="element-1343">
                    {[{
                id: 'growth',
                label: 'Growth Metrics',
                icon: BarChart3
              }, {
                id: 'production',
                label: 'Production Desk',
                icon: PenTool
              }, {
                id: 'crm',
                label: 'CRM & Lead Hub',
                icon: Users
              }, {
                id: 'scaling',
                label: 'Scaling Tools',
                icon: Layers
              }].map(tab => <button key={tab.id} onClick={() => setActiveTab(tab.id)} className={`flex items-center gap-2 px-6 py-4 text-sm font-bold whitespace-nowrap transition-all border-b-2 ${activeTab === tab.id ? 'border-[#002366] text-[#002366]' : 'border-transparent text-slate-400 hover:text-slate-600'}`} data-id="element-1344">
                        <tab.icon size={18} data-id="element-1345" />
                        {tab.label}
                      </button>)}
                  </div>

                  <div className="p-8" data-id="element-1346">
                    {activeTab === 'growth' && <div className="space-y-8" data-id="element-1347">
                        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-1348">
                          <div className="p-6 bg-slate-50 rounded-xl border border-slate-100" data-id="element-1349">
                            <p className="text-xs font-bold text-slate-400 uppercase tracking-widest mb-2" data-id="element-1350">
                              Total Member Signups
                            </p>
                            <h3 className="text-3xl font-bold text-[#002366]" data-id="element-1351">
                              1,284
                            </h3>
                            <div className="mt-4 flex items-center gap-2 text-emerald-600 text-xs font-bold" data-id="element-1352">
                              <TrendingUp size={14} data-id="element-1353" /> +12% this month
                            </div>
                          </div>
                          <div className="p-6 bg-slate-50 rounded-xl border border-slate-100" data-id="element-1354">
                            <p className="text-xs font-bold text-slate-400 uppercase tracking-widest mb-2" data-id="element-1355">
                              Total Sales Revenue
                            </p>
                            <h3 className="text-3xl font-bold text-[#002366]" data-id="element-1356">
                              $42,900.00
                            </h3>
                            <div className="mt-4 flex items-center gap-2 text-emerald-600 text-xs font-bold" data-id="element-1357">
                              <TrendingUp size={14} data-id="element-1358" /> +8% this month
                            </div>
                          </div>
                          <div className="p-6 bg-slate-50 rounded-xl border border-slate-100" data-id="element-1359">
                            <p className="text-xs font-bold text-slate-400 uppercase tracking-widest mb-2" data-id="element-1360">
                              Active Subscriptions
                            </p>
                            <h3 className="text-3xl font-bold text-[#002366]" data-id="element-1361">
                              842
                            </h3>
                            <div className="mt-4 flex items-center gap-2 text-emerald-600 text-xs font-bold" data-id="element-1362">
                              <TrendingUp size={14} data-id="element-1363" /> +5% this month
                            </div>
                          </div>
                        </div>
                        <div className="h-[300px] w-full" data-id="element-1364">
                          <ResponsiveContainer width="100%" height="100%" data-id="element-1365">
                            <AreaChart data={growthData} data-id="element-1366">
                              <defs data-id="element-1367">
                                <linearGradient id="colorTraffic" x1="0" y1="0" x2="0" y2="1" data-id="element-1368">
                                  <stop offset="5%" stopColor="#002366" stopOpacity={0.1} data-id="element-1369" />
                                  <stop offset="95%" stopColor="#002366" stopOpacity={0} data-id="element-1370" />
                                </linearGradient>
                              </defs>
                              <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#f1f5f9" data-id="element-1371" />
                              <XAxis dataKey="name" axisLine={false} tickLine={false} tick={{
                        fontSize: 12,
                        fill: '#94a3b8'
                      }} data-id="element-1372" />
                              <YAxis axisLine={false} tickLine={false} tick={{
                        fontSize: 12,
                        fill: '#94a3b8'
                      }} data-id="element-1373" />
                              <Tooltip data-id="element-1374" />
                              <Area type="monotone" dataKey="traffic" stroke="#002366" strokeWidth={3} fillOpacity={1} fill="url(#colorTraffic)" data-id="element-1375" />
                              <Area type="monotone" dataKey="roi" stroke="#00E5FF" strokeWidth={3} fill="transparent" data-id="element-1376" />
                            </AreaChart>
                          </ResponsiveContainer>
                        </div>
                      </div>}

                    {activeTab === 'production' && <div className="grid grid-cols-1 lg:grid-cols-2 gap-8" data-id="element-1377">
                        <div className="space-y-6" data-id="element-1378">
                          <h3 className="font-bold text-[#002366] flex items-center gap-2" data-id="element-1379">
                            <PenTool size={20} data-id="element-1380" /> Design Suite
                          </h3>
                          <div className="grid grid-cols-2 gap-4" data-id="element-1381">
                            <button className="p-6 bg-slate-50 border border-slate-100 rounded-xl hover:border-blue-200 transition-all text-left group" data-id="element-1382">
                              <Printer className="text-blue-600 mb-4" size={24} data-id="element-1383" />
                              <p className="font-bold text-sm mb-1" data-id="element-1384">
                                Business Cards
                              </p>
                              <p className="text-xs text-slate-400" data-id="element-1385">
                                Launch template editor
                              </p>
                            </button>
                            <button className="p-6 bg-slate-50 border border-slate-100 rounded-xl hover:border-blue-200 transition-all text-left group" data-id="element-1386">
                              <Layout className="text-cyan-600 mb-4" size={24} data-id="element-1387" />
                              <p className="font-bold text-sm mb-1" data-id="element-1388">
                                Flyer Designer
                              </p>
                              <p className="text-xs text-slate-400" data-id="element-1389">
                                Launch template editor
                              </p>
                            </button>
                          </div>
                          <div className="p-6 bg-blue-50 rounded-xl border border-blue-100" data-id="element-1390">
                            <h4 className="font-bold text-[#002366] text-sm mb-4" data-id="element-1391">
                              Brand Identity Hub
                            </h4>
                            <div className="space-y-4" data-id="element-1392">
                              <div className="flex items-center justify-between p-3 bg-white rounded-lg border border-blue-100" data-id="element-1393">
                                <span className="text-xs font-bold" data-id="element-1394">
                                  Primary Logo
                                </span>
                                <button className="text-[10px] font-bold text-blue-600 uppercase" data-id="element-1395">
                                  Update
                                </button>
                              </div>
                              <div className="flex items-center justify-between p-3 bg-white rounded-lg border border-blue-100" data-id="element-1396">
                                <span className="text-xs font-bold" data-id="element-1397">
                                  Brand Colors
                                </span>
                                <div className="flex gap-1" data-id="element-1398">
                                  <div className="w-4 h-4 rounded bg-[#002366]" data-id="element-1399"></div>
                                  <div className="w-4 h-4 rounded bg-[#00E5FF]" data-id="element-1400"></div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="space-y-6" data-id="element-1401">
                          <h3 className="font-bold text-[#002366] flex items-center gap-2" data-id="element-1402">
                            <Printer size={20} data-id="element-1403" /> Print Queue
                          </h3>
                          <div className="space-y-3" data-id="element-1404">
                            {[{
                      id: 'ORD-902',
                      item: 'Premium Business Cards (500)',
                      status: 'In Production',
                      color: 'text-amber-600',
                      bg: 'bg-amber-50'
                    }, {
                      id: 'ORD-899',
                      item: 'Event Banners (2)',
                      status: 'Shipped',
                      color: 'text-emerald-600',
                      bg: 'bg-emerald-50'
                    }, {
                      id: 'ORD-895',
                      item: 'Marketing Flyers (1000)',
                      status: 'Delivered',
                      color: 'text-slate-400',
                      bg: 'bg-slate-50'
                    }].map(order => <div key={order.id} className="p-4 bg-white border border-slate-100 rounded-xl flex items-center justify-between" data-id="element-1405">
                                <div data-id="element-1406">
                                  <p className="text-xs font-bold text-[#002366]" data-id="element-1407">
                                    {order.item}
                                  </p>
                                  <p className="text-[10px] font-bold text-slate-400 uppercase" data-id="element-1408">
                                    {order.id}
                                  </p>
                                </div>
                                <span className={`px-3 py-1 rounded-full text-[10px] font-bold uppercase tracking-wider ${order.bg} ${order.color}`} data-id="element-1409">
                                  {order.status}
                                </span>
                              </div>)}
                          </div>
                          <button className="w-full py-3 border-2 border-dashed border-slate-200 rounded-xl text-slate-400 text-xs font-bold hover:border-blue-200 hover:text-blue-600 transition-all" data-id="element-1410">
                            + Submit New Print Order
                          </button>
                        </div>
                      </div>}

                    {activeTab === 'crm' && <div className="space-y-6" data-id="element-1411">
                        <div className="flex items-center justify-between" data-id="element-1412">
                          <h3 className="font-bold text-[#002366]" data-id="element-1413">
                            Lead Management
                          </h3>
                          <button className="bg-[#002366] text-white px-4 py-2 rounded-lg text-xs font-bold flex items-center gap-2" data-id="element-1414">
                            <Plus size={16} data-id="element-1415" /> Manual Lead Entry
                          </button>
                        </div>
                        <div className="overflow-x-auto" data-id="element-1416">
                          <table className="w-full text-left border-collapse" data-id="element-1417">
                            <thead data-id="element-1418">
                              <tr className="text-[10px] font-bold uppercase tracking-widest text-slate-400 border-b border-slate-100" data-id="element-1419">
                                <th className="px-4 py-4" data-id="element-1420">Lead Name</th>
                                <th className="px-4 py-4" data-id="element-1421">Source</th>
                                <th className="px-4 py-4" data-id="element-1422">Status</th>
                                <th className="px-4 py-4" data-id="element-1423">Last Contact</th>
                                <th className="px-4 py-4 text-right" data-id="element-1424">
                                  Actions
                                </th>
                              </tr>
                            </thead>
                            <tbody className="text-sm" data-id="element-1425">
                              {[{
                        name: 'Sarah Jenkins',
                        source: 'Smart Assistant',
                        status: 'Hot',
                        date: '2 hours ago'
                      }, {
                        name: 'Robert Chen',
                        source: 'Landing Page',
                        status: 'Warm',
                        date: '5 hours ago'
                      }, {
                        name: 'Michael Ross',
                        source: 'Direct Search',
                        status: 'New',
                        date: '1 day ago'
                      }, {
                        name: 'Elena Gilbert',
                        source: 'Chatbot',
                        status: 'Follow-up',
                        date: '2 days ago'
                      }].map((lead, i) => <tr key={i} className="border-b border-slate-50 hover:bg-slate-50 transition-colors" data-id="element-1426">
                                  <td className="px-4 py-4 font-bold text-[#002366]" data-id="element-1427">
                                    {lead.name}
                                  </td>
                                  <td className="px-4 py-4 text-slate-500" data-id="element-1428">
                                    {lead.source}
                                  </td>
                                  <td className="px-4 py-4" data-id="element-1429">
                                    <span className={`px-2 py-0.5 rounded text-[10px] font-bold uppercase ${lead.status === 'Hot' ? 'bg-red-50 text-red-600' : lead.status === 'Warm' ? 'bg-amber-50 text-amber-600' : 'bg-blue-50 text-blue-600'}`} data-id="element-1430">
                                      {lead.status}
                                    </span>
                                  </td>
                                  <td className="px-4 py-4 text-slate-400 text-xs" data-id="element-1431">
                                    {lead.date}
                                  </td>
                                  <td className="px-4 py-4 text-right" data-id="element-1432">
                                    <div className="flex justify-end gap-2" data-id="element-1433">
                                      <button className="p-1.5 text-slate-400 hover:text-blue-600 transition-colors" title="Add Note" data-id="element-1434">
                                        <FileText size={16} data-id="element-1435" />
                                      </button>
                                      <button className="p-1.5 text-slate-400 hover:text-blue-600 transition-colors" title="Set Follow-up" data-id="element-1436">
                                        <Bell size={16} data-id="element-1437" />
                                      </button>
                                    </div>
                                  </td>
                                </tr>)}
                            </tbody>
                          </table>
                        </div>
                      </div>}

                    {activeTab === 'scaling' && <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-1438">
                        <div className="p-8 bg-slate-50 rounded-2xl border border-slate-100 space-y-6" data-id="element-1439">
                          <div className="w-12 h-12 bg-blue-600 text-white rounded-xl flex items-center justify-center" data-id="element-1440">
                            <Layout size={24} data-id="element-1441" />
                          </div>
                          <div data-id="element-1442">
                            <h4 className="text-xl font-bold text-[#002366] mb-2" data-id="element-1443">
                              Landing Page Builder
                            </h4>
                            <p className="text-sm text-slate-500 mb-6" data-id="element-1444">
                              Create high-converting landing pages for your
                              clients in seconds using our drag-and-drop engine.
                            </p>
                            <button onClick={() => setAgentSubPage('builder')} className="text-sm font-bold text-blue-600 flex items-center gap-2" data-id="element-1445">
                              Launch Builder <ArrowRight size={16} data-id="element-1446" />
                            </button>
                          </div>
                        </div>
                        <div className="p-8 bg-slate-50 rounded-2xl border border-slate-100 space-y-6" data-id="element-1447">
                          <div className="w-12 h-12 bg-cyan-500 text-white rounded-xl flex items-center justify-center" data-id="element-1448">
                            <MousePointer2 size={24} data-id="element-1449" />
                          </div>
                          <div data-id="element-1450">
                            <h4 className="text-xl font-bold text-[#002366] mb-2" data-id="element-1451">
                              Custom Form Generator
                            </h4>
                            <p className="text-sm text-slate-500 mb-6" data-id="element-1452">
                              Build smart lead capture forms that integrate
                              directly with your CRM and automated workflows.
                            </p>
                            <button onClick={() => setAgentSubPage('forms')} className="text-sm font-bold text-cyan-600 flex items-center gap-2" data-id="element-1453">
                              Create New Form <ArrowRight size={16} data-id="element-1454" />
                            </button>
                          </div>
                        </div>
                        <div className="p-8 bg-slate-50 rounded-2xl border border-slate-100 space-y-6" data-id="element-1455">
                          <div className="w-12 h-12 bg-indigo-600 text-white rounded-xl flex items-center justify-center" data-id="element-1456">
                            <Shield size={24} data-id="element-1457" />
                          </div>
                          <div data-id="element-1458">
                            <h4 className="text-xl font-bold text-[#002366] mb-2" data-id="element-1459">
                              Managed SSL & Security
                            </h4>
                            <p className="text-sm text-slate-500 mb-6" data-id="element-1460">
                              Deploy enterprise-grade security certificates and
                              DDoS protection for every client site
                              automatically.
                            </p>
                            <button onClick={() => setAgentSubPage('security')} className="text-sm font-bold text-indigo-600 flex items-center gap-2" data-id="element-1461">
                              Manage Security <ArrowRight size={16} data-id="element-1462" />
                            </button>
                          </div>
                        </div>
                        <div className="p-8 bg-slate-50 rounded-2xl border border-slate-100 space-y-6" data-id="element-1463">
                          <div className="w-12 h-12 bg-slate-800 text-white rounded-xl flex items-center justify-center" data-id="element-1464">
                            <Globe size={24} data-id="element-1465" />
                          </div>
                          <div data-id="element-1466">
                            <h4 className="text-xl font-bold text-[#002366] mb-2" data-id="element-1467">
                              Multi-Node Hosting
                            </h4>
                            <p className="text-sm text-slate-500 mb-6" data-id="element-1468">
                              Provision new server nodes and manage resource
                              allocation across your entire agent network.
                            </p>
                            <button onClick={() => setAgentSubPage('nodes')} className="text-sm font-bold text-slate-800 flex items-center gap-2" data-id="element-1469">
                              Open Hosting Manager <ArrowRight size={16} data-id="element-1470" />
                            </button>
                          </div>
                        </div>
                      </div>}
                  </div>
                </div>
              </> /* Agent Sub-Pages */ : <div className="space-y-6" data-id="element-1471">
                <button onClick={() => setAgentSubPage(null)} className="flex items-center gap-2 text-sm font-bold text-slate-400 hover:text-[#002366] transition-colors mb-4" data-id="element-1472">
                  <ArrowRight className="rotate-180" size={16} data-id="element-1473" /> Back to Nerve
                  Center
                </button>

                {agentSubPage === 'builder' && <div className="bg-white rounded-2xl border border-slate-200 shadow-xl overflow-hidden flex flex-col h-[80vh]" data-id="element-1474">
                    <div className="p-4 border-b border-slate-100 flex items-center justify-between bg-slate-50/50" data-id="element-1475">
                      <div className="flex items-center gap-4" data-id="element-1476">
                        <h2 className="font-bold text-[#002366]" data-id="element-1477">
                          Landing Page Builder
                        </h2>
                        <div className="h-4 w-px bg-slate-200" data-id="element-1478"></div>
                        <span className="text-xs font-medium text-slate-400 italic" data-id="element-1479">
                          Draft: Summer Campaign 2024
                        </span>
                      </div>
                      <div className="flex gap-2" data-id="element-1480">
                        <button className="px-3 py-1.5 text-xs font-bold text-slate-600 hover:bg-white rounded-lg border border-transparent hover:border-slate-200 transition-all" data-id="element-1481">
                          Preview
                        </button>
                        <button className="px-4 py-1.5 text-xs font-bold bg-[#002366] text-white rounded-lg shadow-lg" data-id="element-1482">
                          Publish Page
                        </button>
                      </div>
                    </div>
                    <div className="flex-1 flex overflow-hidden" data-id="element-1483">
                      <div className="w-64 border-r border-slate-100 p-4 space-y-6 overflow-y-auto" data-id="element-1484">
                        <div data-id="element-1485">
                          <p className="text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-4" data-id="element-1486">
                            Components
                          </p>
                          <div className="grid grid-cols-2 gap-2" data-id="element-1487">
                            {['Hero', 'Features', 'Pricing', 'Testimonials', 'FAQ', 'Footer'].map(c => <div key={c} className="p-3 bg-slate-50 border border-slate-100 rounded-lg text-[10px] font-bold text-center cursor-move hover:border-blue-200 hover:text-blue-600 transition-all" data-id="element-1488">
                                {c}
                              </div>)}
                          </div>
                        </div>
                        <div data-id="element-1489">
                          <p className="text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-4" data-id="element-1490">
                            Settings
                          </p>
                          <div className="space-y-3" data-id="element-1491">
                            <div className="space-y-1" data-id="element-1492">
                              <label className="text-[10px] font-bold text-slate-500" data-id="element-1493">
                                Primary Color
                              </label>
                              <div className="h-8 bg-blue-600 rounded-lg cursor-pointer" data-id="element-1494"></div>
                            </div>
                            <div className="space-y-1" data-id="element-1495">
                              <label className="text-[10px] font-bold text-slate-500" data-id="element-1496">
                                Font Family
                              </label>
                              <select className="w-full p-2 bg-slate-50 border border-slate-100 rounded-lg text-[10px] font-bold outline-none" data-id="element-1497">
                                <option data-id="element-1498">Inter Sans</option>
                                <option data-id="element-1499">Roboto</option>
                                <option data-id="element-1500">Montserrat</option>
                              </select>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="flex-1 bg-slate-100 p-8 overflow-y-auto" data-id="element-1501">
                        <div className="max-w-3xl mx-auto bg-white aspect-[1/1.4] shadow-2xl rounded-lg border border-slate-200 p-12 flex flex-col items-center justify-center text-center space-y-6" data-id="element-1502">
                          <div className="w-20 h-20 bg-blue-50 rounded-full flex items-center justify-center" data-id="element-1503">
                            <Plus className="text-blue-600" size={32} data-id="element-1504" />
                          </div>
                          <div data-id="element-1505">
                            <h3 className="text-2xl font-bold text-[#002366]" data-id="element-1506">
                              Start Building
                            </h3>
                            <p className="text-slate-400 text-sm" data-id="element-1507">
                              Drag components from the sidebar to begin
                              designing your high-converting landing page.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>}

                {agentSubPage === 'forms' && <div className="grid grid-cols-1 lg:grid-cols-3 gap-8" data-id="element-1508">
                    <div className="lg:col-span-2 space-y-6" data-id="element-1509">
                      <div className="bg-white p-8 rounded-2xl border border-slate-200 shadow-sm space-y-8" data-id="element-1510">
                        <div className="flex items-center justify-between" data-id="element-1511">
                          <h2 className="text-xl font-bold text-[#002366]" data-id="element-1512">
                            Form Generator
                          </h2>
                          <span className="px-3 py-1 bg-emerald-50 text-emerald-600 rounded-full text-[10px] font-bold uppercase" data-id="element-1513">
                            Auto-Sync Active
                          </span>
                        </div>
                        <div className="space-y-4" data-id="element-1514">
                          {[{
                    label: 'Full Name',
                    type: 'Text Input',
                    required: true
                  }, {
                    label: 'Email Address',
                    type: 'Email Input',
                    required: true
                  }, {
                    label: 'Phone Number',
                    type: 'Phone Input',
                    required: false
                  }, {
                    label: 'Service Interest',
                    type: 'Dropdown',
                    required: true
                  }].map((field, i) => <div key={i} className="p-4 bg-slate-50 border border-slate-100 rounded-xl flex items-center justify-between group" data-id="element-1515">
                              <div className="flex items-center gap-4" data-id="element-1516">
                                <div className="w-8 h-8 bg-white border border-slate-200 rounded flex items-center justify-center text-slate-400" data-id="element-1517">
                                  <Menu size={14} data-id="element-1518" />
                                </div>
                                <div data-id="element-1519">
                                  <p className="text-sm font-bold text-[#002366]" data-id="element-1520">
                                    {field.label}
                                  </p>
                                  <p className="text-[10px] text-slate-400 uppercase font-bold" data-id="element-1521">
                                    {field.type}
                                  </p>
                                </div>
                              </div>
                              <div className="flex items-center gap-3 opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-1522">
                                <button className="p-1.5 text-slate-400 hover:text-blue-600" data-id="element-1523">
                                  <Settings size={14} data-id="element-1524" />
                                </button>
                                <button className="p-1.5 text-slate-400 hover:text-red-600" data-id="element-1525">
                                  <X size={14} data-id="element-1526" />
                                </button>
                              </div>
                            </div>)}
                          <button className="w-full py-4 border-2 border-dashed border-slate-200 rounded-xl text-slate-400 text-sm font-bold hover:border-blue-200 hover:text-blue-600 transition-all flex items-center justify-center gap-2" data-id="element-1527">
                            <Plus size={18} data-id="element-1528" /> Add New Field
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className="space-y-6" data-id="element-1529">
                      <div className="bg-[#002366] p-6 rounded-2xl text-white shadow-xl" data-id="element-1530">
                        <h3 className="font-bold mb-4 flex items-center gap-2" data-id="element-1531">
                          <Zap className="text-[#00E5FF]" size={18} data-id="element-1532" />{' '}
                          Integration Hub
                        </h3>
                        <p className="text-xs text-blue-100 mb-6 leading-relaxed" data-id="element-1533">
                          This form is automatically connected to your CRM and
                          will trigger a "New Lead" notification for every
                          submission.
                        </p>
                        <div className="space-y-3" data-id="element-1534">
                          <div className="flex items-center justify-between p-3 bg-white/10 rounded-lg border border-white/10" data-id="element-1535">
                            <span className="text-xs font-bold" data-id="element-1536">CRM Sync</span>
                            <div className="w-8 h-4 bg-[#00E5FF] rounded-full relative" data-id="element-1537">
                              <div className="absolute right-1 top-1 w-2 h-2 bg-[#002366] rounded-full" data-id="element-1538"></div>
                            </div>
                          </div>
                          <div className="flex items-center justify-between p-3 bg-white/10 rounded-lg border border-white/10" data-id="element-1539">
                            <span className="text-xs font-bold" data-id="element-1540">
                              Email Alerts
                            </span>
                            <div className="w-8 h-4 bg-[#00E5FF] rounded-full relative" data-id="element-1541">
                              <div className="absolute right-1 top-1 w-2 h-2 bg-[#002366] rounded-full" data-id="element-1542"></div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="bg-white p-6 rounded-2xl border border-slate-200 shadow-sm" data-id="element-1543">
                        <h3 className="font-bold text-[#002366] mb-4" data-id="element-1544">
                          Embed Code
                        </h3>
                        <div className="bg-slate-50 p-4 rounded-xl font-mono text-[10px] text-slate-500 break-all border border-slate-100" data-id="element-1545">
                          &lt;script
                          src="https://cdn.myspeedyx.com/forms/f_8921.js"&gt;&lt;/script&gt;
                        </div>
                        <button className="w-full mt-4 py-2 text-xs font-bold text-blue-600 hover:bg-blue-50 rounded-lg transition-all" data-id="element-1546">
                          Copy Embed Code
                        </button>
                      </div>
                    </div>
                  </div>}

                {agentSubPage === 'security' && <div className="space-y-8" data-id="element-1547">
                    <div className="grid grid-cols-1 md:grid-cols-4 gap-6" data-id="element-1548">
                      <div className="p-6 bg-white rounded-2xl border border-slate-200 shadow-sm" data-id="element-1549">
                        <p className="text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-2" data-id="element-1550">
                          Active SSLs
                        </p>
                        <h3 className="text-2xl font-bold text-[#002366]" data-id="element-1551">
                          142
                        </h3>
                        <p className="text-[10px] text-emerald-600 font-bold mt-2 flex items-center gap-1" data-id="element-1552">
                          <CheckCircle2 size={12} data-id="element-1553" /> 100% Secure
                        </p>
                      </div>
                      <div className="p-6 bg-white rounded-2xl border border-slate-200 shadow-sm" data-id="element-1554">
                        <p className="text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-2" data-id="element-1555">
                          DDoS Attacks Blocked
                        </p>
                        <h3 className="text-2xl font-bold text-[#002366]" data-id="element-1556">
                          8,921
                        </h3>
                        <p className="text-[10px] text-blue-600 font-bold mt-2 flex items-center gap-1" data-id="element-1557">
                          <Shield size={12} data-id="element-1558" /> Real-time Protection
                        </p>
                      </div>
                      <div className="p-6 bg-white rounded-2xl border border-slate-200 shadow-sm" data-id="element-1559">
                        <p className="text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-2" data-id="element-1560">
                          Firewall Events
                        </p>
                        <h3 className="text-2xl font-bold text-[#002366]" data-id="element-1561">
                          42k
                        </h3>
                        <p className="text-[10px] text-slate-400 font-bold mt-2" data-id="element-1562">
                          Last 24 hours
                        </p>
                      </div>
                      <div className="p-6 bg-white rounded-2xl border border-slate-200 shadow-sm" data-id="element-1563">
                        <p className="text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-2" data-id="element-1564">
                          Global CDN Status
                        </p>
                        <h3 className="text-2xl font-bold text-emerald-600" data-id="element-1565">
                          Optimal
                        </h3>
                        <p className="text-[10px] text-slate-400 font-bold mt-2" data-id="element-1566">
                          12 Edge Nodes Active
                        </p>
                      </div>
                    </div>
                    <div className="bg-white rounded-2xl border border-slate-200 shadow-sm overflow-hidden" data-id="element-1567">
                      <div className="p-6 border-b border-slate-100 flex items-center justify-between" data-id="element-1568">
                        <h3 className="font-bold text-[#002366]" data-id="element-1569">
                          Client Security Overview
                        </h3>
                        <div className="flex gap-2" data-id="element-1570">
                          <button className="p-2 text-slate-400 hover:text-[#002366] transition-colors" data-id="element-1571">
                            <Search size={18} data-id="element-1572" />
                          </button>
                          <button className="px-4 py-2 bg-[#002366] text-white rounded-lg text-xs font-bold" data-id="element-1573">
                            Bulk SSL Renew
                          </button>
                        </div>
                      </div>
                      <div className="overflow-x-auto" data-id="element-1574">
                        <table className="w-full text-left border-collapse" data-id="element-1575">
                          <thead data-id="element-1576">
                            <tr className="text-[10px] font-bold uppercase tracking-widest text-slate-400 border-b border-slate-100" data-id="element-1577">
                              <th className="px-6 py-4" data-id="element-1578">Domain</th>
                              <th className="px-6 py-4" data-id="element-1579">SSL Status</th>
                              <th className="px-6 py-4" data-id="element-1580">Security Tier</th>
                              <th className="px-6 py-4" data-id="element-1581">Expiry</th>
                              <th className="px-6 py-4 text-right" data-id="element-1582">Actions</th>
                            </tr>
                          </thead>
                          <tbody className="text-sm" data-id="element-1583">
                            {[{
                      domain: 'techflow.io',
                      status: 'Active',
                      tier: 'Enterprise',
                      expiry: '240 Days'
                    }, {
                      domain: 'urbanstyle.com',
                      status: 'Active',
                      tier: 'Standard',
                      expiry: '12 Days'
                    }, {
                      domain: 'nexus-app.net',
                      status: 'Pending',
                      tier: 'Enterprise',
                      expiry: '-'
                    }, {
                      domain: 'global-logistics.ca',
                      status: 'Active',
                      tier: 'Standard',
                      expiry: '310 Days'
                    }].map((site, i) => <tr key={i} className="border-b border-slate-50 hover:bg-slate-50 transition-colors" data-id="element-1584">
                                <td className="px-6 py-4 font-bold text-[#002366]" data-id="element-1585">
                                  {site.domain}
                                </td>
                                <td className="px-6 py-4" data-id="element-1586">
                                  <span className={`px-2 py-0.5 rounded text-[10px] font-bold uppercase ${site.status === 'Active' ? 'bg-emerald-50 text-emerald-600' : 'bg-amber-50 text-amber-600'}`} data-id="element-1587">
                                    {site.status}
                                  </span>
                                </td>
                                <td className="px-6 py-4 text-slate-500 font-medium" data-id="element-1588">
                                  {site.tier}
                                </td>
                                <td className="px-6 py-4 text-slate-400 text-xs" data-id="element-1589">
                                  {site.expiry}
                                </td>
                                <td className="px-6 py-4 text-right" data-id="element-1590">
                                  <button className="text-xs font-bold text-blue-600 hover:underline" data-id="element-1591">
                                    Manage
                                  </button>
                                </td>
                              </tr>)}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>}

                {agentSubPage === 'nodes' && <div className="space-y-8" data-id="element-1592">
                    <div className="flex items-center justify-between" data-id="element-1593">
                      <div data-id="element-1594">
                        <h2 className="text-2xl font-bold text-[#002366]" data-id="element-1595">
                          Multi-Node Hosting Manager
                        </h2>
                        <p className="text-slate-500 text-sm" data-id="element-1596">
                          Wholesale resource allocation across your agent
                          network.
                        </p>
                      </div>
                      <button className="bg-[#002366] text-white px-6 py-3 rounded-xl font-bold text-sm flex items-center gap-2 shadow-xl shadow-blue-900/20" data-id="element-1597">
                        <Plus size={18} data-id="element-1598" /> Provision New Node
                      </button>
                    </div>
                    <div className="grid grid-cols-1 lg:grid-cols-3 gap-8" data-id="element-1599">
                      <div className="lg:col-span-2 space-y-6" data-id="element-1600">
                        {[{
                  name: 'Cluster Alpha (US-East)',
                  nodes: 12,
                  load: 42,
                  ram: 64,
                  storage: 1.2
                }, {
                  name: 'Cluster Beta (CA-Central)',
                  nodes: 8,
                  load: 78,
                  ram: 32,
                  storage: 0.8
                }, {
                  name: 'Cluster Gamma (US-West)',
                  nodes: 15,
                  load: 15,
                  ram: 128,
                  storage: 2.4
                }].map((cluster, i) => <div key={i} className="bg-white p-6 rounded-2xl border border-slate-200 shadow-sm hover:border-blue-200 transition-all" data-id="element-1601">
                            <div className="flex items-center justify-between mb-6" data-id="element-1602">
                              <div className="flex items-center gap-3" data-id="element-1603">
                                <div className="w-10 h-10 bg-slate-900 text-white rounded-lg flex items-center justify-center" data-id="element-1604">
                                  <Layers size={20} data-id="element-1605" />
                                </div>
                                <div data-id="element-1606">
                                  <h4 className="font-bold text-[#002366]" data-id="element-1607">
                                    {cluster.name}
                                  </h4>
                                  <p className="text-[10px] text-slate-400 font-bold uppercase" data-id="element-1608">
                                    {cluster.nodes} Active Nodes
                                  </p>
                                </div>
                              </div>
                              <div className="text-right" data-id="element-1609">
                                <p className="text-xs font-bold text-slate-400 uppercase tracking-widest mb-1" data-id="element-1610">
                                  Load Status
                                </p>
                                <span className={`px-2 py-0.5 rounded text-[10px] font-bold uppercase ${cluster.load > 70 ? 'bg-red-50 text-red-600' : 'bg-emerald-50 text-emerald-600'}`} data-id="element-1611">
                                  {cluster.load > 70 ? 'High Load' : 'Healthy'}
                                </span>
                              </div>
                            </div>
                            <div className="grid grid-cols-3 gap-6" data-id="element-1612">
                              <div className="space-y-2" data-id="element-1613">
                                <div className="flex justify-between text-[10px] font-bold text-slate-400 uppercase" data-id="element-1614">
                                  <span data-id="element-1615">CPU Load</span>
                                  <span data-id="element-1616">{cluster.load}%</span>
                                </div>
                                <div className="w-full bg-slate-100 h-1.5 rounded-full overflow-hidden" data-id="element-1617">
                                  <div className={`h-full ${cluster.load > 70 ? 'bg-red-500' : 'bg-blue-600'}`} style={{
                          width: `${cluster.load}%`
                        }} data-id="element-1618"></div>
                                </div>
                              </div>
                              <div className="space-y-2" data-id="element-1619">
                                <div className="flex justify-between text-[10px] font-bold text-slate-400 uppercase" data-id="element-1620">
                                  <span data-id="element-1621">RAM Usage</span>
                                  <span data-id="element-1622">
                                    {Math.floor(cluster.ram * 0.6)}GB /{' '}
                                    {cluster.ram}GB
                                  </span>
                                </div>
                                <div className="w-full bg-slate-100 h-1.5 rounded-full overflow-hidden" data-id="element-1623">
                                  <div className="h-full bg-indigo-600" style={{
                          width: '60%'
                        }} data-id="element-1624"></div>
                                </div>
                              </div>
                              <div className="space-y-2" data-id="element-1625">
                                <div className="flex justify-between text-[10px] font-bold text-slate-400 uppercase" data-id="element-1626">
                                  <span data-id="element-1627">Storage</span>
                                  <span data-id="element-1628">{cluster.storage}TB / 5TB</span>
                                </div>
                                <div className="w-full bg-slate-100 h-1.5 rounded-full overflow-hidden" data-id="element-1629">
                                  <div className="h-full bg-cyan-500" style={{
                          width: `${cluster.storage / 5 * 100}%`
                        }} data-id="element-1630"></div>
                                </div>
                              </div>
                            </div>
                          </div>)}
                      </div>
                      <div className="space-y-6" data-id="element-1631">
                        <div className="bg-white p-6 rounded-2xl border border-slate-200 shadow-sm" data-id="element-1632">
                          <h3 className="font-bold text-[#002366] mb-4" data-id="element-1633">
                            Resource Allocation
                          </h3>
                          <div className="h-[200px] w-full" data-id="element-1634">
                            <ResponsiveContainer width="100%" height="100%" data-id="element-1635">
                              <BarChart data={[{
                        name: 'Hosting',
                        val: 45
                      }, {
                        name: 'Apps',
                        val: 30
                      }, {
                        name: 'Storage',
                        val: 25
                      }]} data-id="element-1636">
                                <XAxis dataKey="name" axisLine={false} tickLine={false} tick={{
                          fontSize: 10,
                          fontBold: true
                        }} data-id="element-1637" />
                                <Bar dataKey="val" fill="#002366" radius={[4, 4, 0, 0]} data-id="element-1638" />
                              </BarChart>
                            </ResponsiveContainer>
                          </div>
                        </div>
                        <div className="bg-slate-900 p-6 rounded-2xl text-white" data-id="element-1639">
                          <h3 className="font-bold mb-4 flex items-center gap-2" data-id="element-1640">
                            <Shield size={18} className="text-[#00E5FF]" data-id="element-1641" /> Node
                            Security
                          </h3>
                          <ul className="space-y-4" data-id="element-1642">
                            {['Automatic OS Patching', 'Kernel-level Isolation', 'Private Network Bridge', 'Snapshot Backups'].map((s, i) => <li key={i} className="flex items-center gap-3 text-xs text-slate-400" data-id="element-1643">
                                <CheckCircle2 size={14} className="text-emerald-500" data-id="element-1644" />{' '}
                                {s}
                              </li>)}
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>}
              </div>}
          </div>
        </main>}

      {/* Smart Assistant Floating Icon */}
      <div className="fixed bottom-8 right-8 z-[100]" data-id="element-1645">
        <motion.button whileHover={{
        scale: 1.1
      }} whileTap={{
        scale: 0.9
      }} className="w-16 h-16 bg-[#002366] text-white rounded-full shadow-2xl flex items-center justify-center group relative" data-id="element-1646">
          <MessageSquare size={28} data-id="element-1647" />
          <span className="absolute right-full mr-4 bg-white text-[#002366] px-4 py-2 rounded-lg text-xs font-bold shadow-xl opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap border border-slate-100" data-id="element-1648">
            Need help scaling? Chat with us!
          </span>
          <span className="absolute top-0 right-0 w-4 h-4 bg-[#00E5FF] rounded-full border-4 border-white" data-id="element-1649"></span>
        </motion.button>
      </div>

      {/* Footer */}
      <footer className="bg-slate-50 border-t border-slate-200 py-12 px-6" data-id="element-1650">
        <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between gap-8" data-id="element-1651">
          <div className="flex items-center gap-2" data-id="element-1652">
            <div className="w-8 h-8 bg-[#002366] rounded flex items-center justify-center" data-id="element-1653">
              <Zap className="text-[#00E5FF]" size={18} data-id="element-1654" />
            </div>
            <span className="font-bold text-lg tracking-tight text-[#002366]" data-id="element-1655">
              MySpeedyX
            </span>
          </div>

          <p className="text-xs font-bold text-slate-400 uppercase tracking-widest" data-id="element-1656">
            Powered by MySpeedyX Enterprise Infrastructure
          </p>

          <div className="flex gap-6 text-xs font-bold text-slate-500 uppercase tracking-widest" data-id="element-1657">
            <a href="#" className="hover:text-[#002366] transition-colors" data-id="element-1658">
              Agent Support
            </a>
            <a href="#" className="hover:text-[#002366] transition-colors" data-id="element-1659">
              Knowledge Base
            </a>
            <a href="#" className="hover:text-[#002366] transition-colors" data-id="element-1660">
              Partner Terms
            </a>
          </div>
        </div>
      </footer>
    </div>;
}